import { Box, Skeleton, useTheme } from '@mui/material';
import { ATSVacanciesModalTestIds } from 'data-testids/ATS';
import { VacancyCTAContainer } from '../styles';

export const VacanciesSkeleton = () => {
  const theme = useTheme();

  return (
    <Box data-testid={ATSVacanciesModalTestIds.SKELETON}>
      <Skeleton sx={{ height: theme.spacing(10) }} />
      <Skeleton sx={{ height: theme.spacing(6) }} />
      <VacancyCTAContainer>
        <Skeleton sx={{ width: '50%', height: theme.spacing(10) }} />
      </VacancyCTAContainer>
    </Box>
  );
};
